export const memberZh = {
  members: {
    //   张小林
    XiaolinZhang: {
      name: '张小林 博士',
      position: ['创始人/首席执行官'],
      edu: ['北京大学客座教授', '美国俄勒冈州立大学分子遗传学博士'],
      detail: [
        '张博士拥有超过20年的新药研发管理经验，曾担任阿斯利康全球创新研发中心副总裁、亚洲及新兴市场创新研发中心负责人。张博士于1998年加入阿斯利康波士顿研究中心，担任全球项目负责人、研发总监等职，也是全球癌症、抗感染研究领域高级管理团队成员之一；2006年，回国建立了阿斯利康中国研发中心，领导了阿斯利康全球肿瘤转化医学、亚洲及新兴市场创新药物研发项目。在阿斯利康任职期间，曾主导或参与了易瑞沙、泰瑞沙，AZD3759、DZD2954等原创新药研发。',
        '曾就职于哈佛大学医学院癌症中心、波士顿大学生物分子工程研究中心等。'
      ]
    },
    // 杨振帆
    PamelaYang: {
      name: '杨振帆 博士',
      position: ['首席医学官'],
      edu: ['香港大学博士', '四川大学华西临床医学院临床医学硕士'],
      detail: [
        '杨博士拥有近10年的一线临床工作经历、10余年的转化医学及新药研发管理经验。曾历任阿斯利康亚洲及新兴市场创新研发中心医学和药物研发项目负责人，生物及临床医学副总裁。在阿斯利康任职期间，先后领导了易瑞沙、泰瑞沙等10余个转化医学项目；主持了AZD3759、AZD1390等多个原创药物研发。',
        '2004年于香港大学任科研教授；作为肝胆外科医生，先后任职于华西医科大学附属第一医院（现四川大学华西医院）、重庆医科大学附属第一医院。'
      ]
    },
    HongbinLyu: {
      name: '吕洪斌先生',
      position: ['首席财务官'],
      edu: ['中央财经大学工商管理硕士、CFA '],
      detail: [
        '吕先生在投资银行及相关业务方面拥有20年经验，曾历任华泰联合大健康行业部负责人、董事总经理以及中金公司成长型企业投资银行部医疗医药行业组负责人。吕先生主导完成的医疗项目包括：药明康德A股和H股IPO，迈瑞医疗A股IPO，三生国健A股科创板IPO，爱尔眼科非公开发行及并购重组，奥赛康药业借壳上市，三生药业港股IPO等。'
      ]
    },
    // 吴清漪
    AnitaWu: {
      name: '吴清漪女士',
      position: ['首席商务官'],
      edu: [''],
      detail: [
        '吴女士拥有超过25年跨国药企和生物科技公司行业经验。 在加入迪哲之前，吴女士担任百济神州大中华区首席商务官，负责建立了商业运营平台及广阔市场团队，以提升团队整合和协作能力和运营效率；主导了三款产品列入国家医保目录。',
        '吴女士还曾供职于赛诺菲、阿斯利康、辉瑞和健赞等跨国药企。在赛诺菲中国任职期间，吴女士担任特药事业部总经理，积极和多方合作，致力于推动中国罕见病政策落地。在阿斯利康中国任职期间，吴女士曾担任糖尿病及代谢业务执行总监。吴女士生物制药经历始于健赞，曾就职于辉瑞公司负责ONC亚太新兴市场。'
      ]
    },
    // 陈素勤
    SusanChen: {
      name: '陈素勤女士',
      position: ['临床运营 高级副总裁'],
      edu: ['中国药科大学中药学学士'],
      detail: [
        '陈女士拥有超过20年的临床运营及管理经验。陈女士曾任阿斯利康中国临床运营中心负责人及罗氏亚太开发中心中国临床管理和监察部负责人。在阿斯利康任职期间，陈女士建立了阿斯利康全球临床运营中国中心，与全球其他三大运营中心并行；领导I至III期全球临床研究，涉及心血管、消化、呼吸及肿瘤等领域，如泰瑞沙、AZD3759、PDL-1、CAZ-AVI 等临床研究，覆盖亚洲、欧洲、美洲三十余个国家。',
        '陈女士在罗氏任职期间，领导中国团队开展三十余项全球或中国注册研究，包括赫赛汀、特罗凯及安维汀等重要产品。陈女士还曾供职礼来、田边制药等跨国医药公司。'
      ]
    },
    // 曾庆北
    QingbeiZeng: {
      name: '曾庆北 博士',
      position: ['首席科学家 高级副总裁'],
      edu: ['美国俄亥俄州立大学化学博士'],
      detail: [
        '曾博士拥有超过20年的新药设计与研发经验，参与了多个创新药物研发项目，涉及癌症、病毒感染、免疫性关节炎、过敏等疾病领域；成功将多个项目推进临床阶段。曾博士曾任阿斯利康中国创新中心高级首席研究员，在阿斯利康任职期间, 是第一个由中国团队自主研发的临床候选新药AZD3759的主要发明人。曾博士还曾先后就职于美国先灵葆雅和默克制药公司。'
      ]
    },
    // 徐汉忠
    HonchungTsui: {
      name: '徐汉忠 博士',
      position: ['药物化学 高级副总裁'],
      edu: ['斯坦福大学博士后', '美国俄亥俄州立大学化学博士'],
      detail: ['徐博士拥有超10年的新药研发工作及管理经验，曾担任阿斯利康投资（中国）有限公司首席科学家。徐博士还曾先后就职于美国先灵葆雅和默克制药公司，曾作为主要成员成功研发了抗化疗呕吐新药Rolapitant，目前已在欧美地区上市；并曾参与了多个肿瘤、免疫相关小分子靶向新药的研发项目。']
    },
    // 张世英博士
    SHIH_YING_CHANG: {
      name: '张世英 博士',
      position: ['化学，生产与控制部副总裁'],
      edu: ['马里兰大学帕克分校化学工程博士'],
      detail: [
        '张博士拥有超过10年创新药制剂开发、技术转移、临床生产经验，曾担任和记黄埔医药制剂研发部执行总监，还曾供职于百时美施贵宝新泽西，致力于研究原料药晶型及干燥，制剂开发，商业化生产放大, 以及技术转移。',
        '曾参与的新药研发项目包括近四十种小分子化合物, 和1个蛋白质分子，涵盖自临床前研究到商业用生产的技术转移；并曾参与撰写5项NDA申请，其中4项向FDA提交、1项向CFDA提交。开发的重要技术包括：溶液型增溶处方、自微乳化释药系统、喷雾干燥分散体、共沉淀、水雾激活干法制粒、活性成分包衣法。'
      ]
    },
    // 张知为
    VioletZhang: {
      name: '张知为女士',
      position: ['公司运营 副总裁'],
      edu: ['香港大学组织与人力资源管理硕士', '华东师范大学法学学士'],
      detail: ['张女士拥有约20年的医疗医药行业管理经验，曾任阿斯利康投资（中国）有限公司人力资源部副总监。']
    },
    HeidiDong: {
      name: '董韡雯女士',
      position: ['董事会秘书'],
      edu: ['广东外语外贸大学外国语言学及应用语言学硕士，持有法律职业资格证书'],
      detail: ['董女士拥有逾十年生物医药领域从业经验，涵盖资本运作、公司治理、投资者关系及产业招商。']
    }
  },
  boards: {
    // 张小林博士
    XiaolinZhang: {
      name: '张小林博士',
      position: ['首席执行官, 迪哲医药'],
      detail: [
        '张博士自2017年起任迪哲医药董事长、首席执行官。',
        '张博士拥有超过20年的新药研发管理经验，曾担任阿斯利康全球创新研发中心副总裁、亚洲及新兴市场创新研发中心负责人。张博士于1998年加入阿斯利康波士顿研究中心，担任全球项目负责人、研发总监等职，也是全球癌症、抗感染研究领域高级管理团队成员之一；2006年，回国建立了阿斯利康中国研发中心，领导了阿斯利康全球肿瘤转化医学、亚洲及新兴市场创新药物研发项目。在阿斯利康任职期间，曾主导或参与了易瑞沙、泰瑞沙，AZD3759、DZD2954等原创新药研发。',
        '曾就职于哈佛大学医学院癌症中心、波士顿大学生物分子工程研究中心等。'
      ]
    },
    // 吕大忠博士
    SimonLu: {
      name: '吕大忠博士',
      position: ['董事总经理, 国投创新投资管理有限公司'],
      detail: [
        '吕博士自2017年起任迪哲医药董事。',
        '吕博士于2009年8月加入国投创新投资管理有限公司，担任董事总经理职务，目前主要负责公司医疗健康领域的投资；曾经就职于中法资本、上海联创投资管理公司、加拿大丰业银行、中国国际金融有限公司和安达信会计师事务所，拥有20多年投资及咨询领域从业经验。吕博士就读于天津南开大学获得经济学学士和博士学位，以及加拿大McGill大学工商管理硕士学位。'
      ]
    },
    /* Rodolphe Grépinet*/
    Rodolphe: {
      name: 'Rodolphe Grépinet',
      position: ['阿斯利康企业发展副总裁'],
      detail: [
        'Grépinet先生自2017年起担任迪哲医药董事。',
        '作为企业发展部负责人兼高级副总裁，Grepinet先生负责阿斯利康在全球所有治疗领域转型机会的评估和执行，直接向首席战略官汇报。过去二十年，Grepinet先生一直参与企业并购和业务拓展交易的评估、构建和谈判，累计成交额超3000亿美元。',
        '在2014年加入阿斯利康之前，Grepinet先生曾在欧洲和美国担任并购投资银行家长达17年，为全球生命科学行业的客户提供咨询服务。他先后在摩根士丹利，瑞银和德意志银行担任要职，最后成为医疗保健并购顾问公司 Torreya Partners 的联合创始合伙人。',
        '他毕业于ESCP商学院，获得管理学硕士学位。'
      ]
    },
    CaoYibo: {
      name: '曹弋博',
      position: ['独立董事'],
      detail: ['曹弋博先生自2026年8月起担任迪哲医药独立董事。', '曹先生目前担任红杉中国董事总经理。2011年8月至2017年7月任Vivo Capital 董事总经理。', '曹先生毕业于北京大学，并获得临床药学专业硕士研究生学历。']
    },
    MeixiaAn: {
      name: '安梅霞女士',
      position: ['独立董事'],
      detail: ['安女士自2024年12月起担任迪哲医药独立董事。', '安女士现任黄山学院经济管理学院教师，曾就职于上海同济科技实业股份有限公司、中国医药工业研究总院、天邦食品股份有限公司。安女士拥有上海财经大学经济学硕士学历，持有注册会计师、高级会计师资格。']
    },
    TianYouWang: {
      name: '王天佑女士',
      position: ['独立董事'],
      detail: ['王女士自2026年1月起担任迪哲医药独立董事。', '王女士是香港证监会持牌负责人员，现任Wisdom Cosmic Hong Kong Limited首席执行官，曾于渣打银行、法国巴黎银行、瑞士联合私立银行、嘉实国际、海通国际、花旗国际等多家金融机构担任高管。']
    },
    LucyKang: {
      name: '康晓静女士',
      position: ['职工代表董事'],
      detail: ['康女士自2025年11月起担任迪哲医药职工董事。', '康女士拥有20余年的财务管理经验，现任迪哲医药财务主管，曾任阿斯利康全球研发中国区财务分析经理。康女士拥有华东理工大学工商管理硕士学历，持有会计师资格。']
    }
  }
}



// WEBPACK FOOTER //
// ./src/lang/member-zh.js